import React from 'react';

import { Select } from '@99designs/common/components/Select';
import { SquarespaceIndustry } from '__generated__/types';
import { handlePromise } from 'common/utils/Bugsnag';
import { ObservableField, ObservableForm } from 'projects/components/ObservableForm';

interface Fields {
    industry: SquarespaceIndustry;
}

interface Props<T> {
    title: string;
    form: ObservableForm<T>;
}

export default function SquarespaceIndustryField<T extends Fields>({ form, title }: Props<T>) {
    return (
        <ObservableField
            form={form}
            name="industry"
            title={title}
            render={() => (
                <Select
                    name="industry"
                    options={[
                        {
                            value: '',
                            disabled: true,
                            label: __('Select industry'),
                        },
                        {
                            value: SquarespaceIndustry.ACCOUNTING_AND_FINANCIAL,
                            label: __('Accounting & financial'),
                        },
                        {
                            value: SquarespaceIndustry.ART_AND_DESIGN,
                            label: __('Art & design'),
                        },
                        {
                            value: SquarespaceIndustry.BEAUTY_AND_PERSONAL_CARE,
                            label: __('Beauty & personal care'),
                        },
                        {
                            value: SquarespaceIndustry.COMMUNITY_AND_NONPROFIT,
                            label: __('Community & nonprofit'),
                        },
                        {
                            value: SquarespaceIndustry.ENTERTAINMENT_AND_MEDIA,
                            label: __('Entertainment & media'),
                        },
                        { value: SquarespaceIndustry.FASHION, label: __('Fashion') },
                        {
                            value: SquarespaceIndustry.FOOD_AND_DRINK,
                            label: __('Food & drink'),
                        },
                        {
                            value: SquarespaceIndustry.HEALTH_AND_FITNESS,
                            label: __('Health & fitness'),
                        },
                        {
                            value: SquarespaceIndustry.HOME_AND_LIVING,
                            label: __('Home & living'),
                        },
                        {
                            value: SquarespaceIndustry.INTERIOR_DESIGN,
                            label: __('Interior design'),
                        },
                        {
                            value: SquarespaceIndustry.LEGAL_SERVICES_AND_ATTORNEYS,
                            label: __('Legal services & attorneys'),
                        },
                        {
                            value: SquarespaceIndustry.MARKETING_AND_ADVERTISING,
                            label: __('Marketing & advertising'),
                        },
                        { value: SquarespaceIndustry.MUSIC, label: __('Music') },
                        { value: SquarespaceIndustry.PHOTOGRAPHY, label: __('Photography') },
                        { value: SquarespaceIndustry.REAL_ESTATE, label: __('Real estate') },
                        {
                            value: SquarespaceIndustry.RETAIL_RESTAURANT_AND_BAR,
                            label: __('Retail, restaurant & bar'),
                        },
                        { value: SquarespaceIndustry.TECHNOLOGY, label: __('Technology') },
                        {
                            value: SquarespaceIndustry.TRAVEL_AND_LIFESTYLE,
                            label: __('Travel & lifecycle'),
                        },
                        { value: SquarespaceIndustry.WEDDING, label: __('Wedding') },
                    ]}
                    value={form.get('industry')}
                    onChange={({ value }) => {
                        handlePromise(
                            form.set('industry', value as SquarespaceIndustry),
                            'SquarespaceIndustrySelect'
                        );
                    }}
                    variations={['max']}
                />
            )}
        />
    );
}
